export const defaultRestaurantData: any = {
    "name": "[DEV] Cafe",
    "address": "India",
    "ownerId": "+916398756486",
    "phone": "+911234567890",
    "ownerPhone": 1234567890,
    "foodType": "Cafe",
    "gstRate": 5,
    "serviceRate": 2.5,
    "discountUpto": 0,
    "roomGST": 12,
    "roomService": 0,
    "ratings": 9,
    "discountPercent": 0,
    "extraDiscountPercent": 0,
    "email": "sample@gmail.com",
    "gstIn": "**** **** ****",
    "logo": "",
    "qrInfo": {
        "tn": "Merchant QR",
        "cu": "INR",
        "mg": "ONLINE",
        "pn": "Pvt. Ltd.",
        "pa": "eazypay.12345@icici",
        "purpose": "00"
    },
    "image": "",
    "managerSign": "",
    "qrCode": "",
    "categoryOrder": [
        "add-ons"
    ],
    "ownerName": "",
    "roomType": {
        "1800": "AC Room",
        "1200": "Non-AC Room",
        "2200": "Deluxe-AC Room"
    },
    "roomDetails": [
        {
            "imageUrl": "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&q=80&w=800",
            "maxGuests": 2,
            "name": "AC Room",
            "pricePerNight": 1800,
            "amenities": [
                "King-size bed",
                "City view",
                "Free WiFi",
                "Smart TV",
                "Mini Bar",
                "Air Conditioning",
                "Room Service",
                "En-suite bathroom",
                "Premium toiletries"
            ],
            "facilities": [
                "Access to fitness center",
                "Pool access",
                "Complimentary breakfast",
                "24/7 concierge service"
            ],
            "totalRooms": 8,
            "description": "Spacious room with a king-size bed and city view"
        },
        {
            "maxGuests": 2,
            "imageUrl": "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&q=80&w=800",
            "name": "Non-AC Room",
            "amenities": [
                "King-size bed",
                "City view",
                "Free WiFi",
                "55 Smart TV",
                "Room Service",
                "En-suite bathroom",
                "Premium toiletries"
            ],
            "totalRooms": 10,
            "facilities": [
                "Complimentary breakfast",
                "24/7 concierge service"
            ],
            "description": "Comfortable room with essential amenities and a city view",
            "pricePerNight": 1200
        },
        {
            "maxGuests": 2,
            "imageUrl": "https://images.unsplash.com/photo-1611892440504-42a792e24d32?auto=format&fit=crop&q=80&w=800",
            "totalRooms": 5,
            "amenities": [
                "King-size bed",
                "City view",
                "Free WiFi",
                "55 Smart TV",
                "Mini Bar",
                "Air Conditioning",
                "Room Service",
                "En-suite bathroom",
                "Premium toiletries"
            ],
            "name": "Deluxe-AC Room",
            "pricePerNight": 2200,
            "description": "Spacious room with a king-size bed and city view",
            "facilities": [
                "Access to fitness center",
                "Pool access",
                "Complimentary breakfast",
                "24/7 concierge service"
            ]
        }
    ],
    "isProd": true,
    "tabs": {
        "room": 5,
        "table": 5
    },
    "location": {
        "latitude": 29.2370384649607,
        "longitude": 78.8546912027923
    },
    "menu": {
        "add-ons": {
            "chocolate": {
                "image": "",
                "available": true,
                "order": 9,
                "variants": [
                    {
                        "size": "Unit",
                        "cost": 30
                    },
                    {
                        "size": "Unit",
                        "cost": 20
                    },
                    {
                        "cost": 10,
                        "size": "Unit"
                    },
                    {
                        "cost": 5,
                        "size": "Unit"
                    },
                    {
                        "size": "Unit",
                        "cost": 40
                    },
                    {
                        "cost": 50,
                        "size": "Unit"
                    },
                    {
                        "size": "Unit",
                        "cost": 100
                    }
                ],
                "type": "veg"
            },
            "ice-cube": {
                "type": "veg",
                "variants": [
                    {
                        "size": "Item",
                        "cost": 50
                    }
                ],
                "image": "",
                "order": 9,
                "available": true
            },
            "ice-cream": {
                "available": true,
                "order": 3,
                "customGST": "10",
                "image": "",
                "type": "veg",
                "variants": [
                    {
                        "size": "Item",
                        "cost": 50
                    },
                    {
                        "size": "Item",
                        "cost": 35
                    },
                    {
                        "cost": 75,
                        "size": "Item"
                    }
                ]
            },
            "soda-bottle": {
                "image": "",
                "order": 4,
                "available": true,
                "type": "veg",
                "variants": [
                    {
                        "cost": 20,
                        "size": "Unit"
                    },
                    {
                        "cost": 30,
                        "size": "Unit"
                    },
                    {
                        "size": "Unit",
                        "cost": 50
                    }
                ]
            },
            "water-bottle": {
                "variants": [
                    {
                        "size": "Unit",
                        "cost": 20
                    },
                    {
                        "size": "Unit",
                        "cost": 30
                    },
                    {
                        "cost": 50,
                        "size": "Unit"
                    }
                ],
                "type": "veg",
                "available": true,
                "order": 2,
                "image": "",
                "customGST": "5"
            },
            "add-on": {
                "image": "",
                "type": "veg",
                "order": 1,
                "available": true,
                "variants": [
                    {
                        "cost": 10,
                        "size": "Item"
                    },
                    {
                        "size": "Item",
                        "cost": 12
                    },
                    {
                        "cost": 15,
                        "size": "Item"
                    },
                    {
                        "size": "Item",
                        "cost": 20
                    },
                    {
                        "size": "Item",
                        "cost": 25
                    },
                    {
                        "cost": 30,
                        "size": "Item"
                    },
                    {
                        "size": "Item",
                        "cost": 35
                    },
                    {
                        "size": "Item",
                        "cost": 40
                    },
                    {
                        "cost": 45,
                        "size": "Item"
                    },
                    {
                        "cost": 50,
                        "size": "Item"
                    },
                    {
                        "size": "Item",
                        "cost": 80
                    },
                    {
                        "cost": 100,
                        "size": "Item"
                    }
                ]
            }
        }
    }
};
